import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "../components/common";
import {
  DashboardGrid,
  LoadingState,
  StatCard,
  StatIcons,
} from "../components/dashboard";
import { COLORS, SPACING } from "../constants/theme";
import { useAuth } from "../hooks/useAuth";
import { getStaffTimeEntries } from "../services/timeEntry.service";
import { getManagerStaff } from "../services/user.service";

export function ManagerDashboard() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [teamMembers, setTeamMembers] = useState(0);
  const [pendingApprovals, setPendingApprovals] = useState(0);
  const [totalHours, setTotalHours] = useState(0);

  useEffect(() => {
    if (currentUser?.uid) loadStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser?.uid]);

  const loadStats = async () => {
    if (!currentUser?.uid || !currentUser?.companyId) return;
    setLoading(true);
    try {
      const staffMembers = await getManagerStaff(currentUser.uid);
      setTeamMembers(staffMembers.length);

      if (staffMembers.length > 0) {
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        const end = new Date(
          now.getFullYear(),
          now.getMonth() + 1,
          0,
          23,
          59,
          59,
        );
        const entries = await getStaffTimeEntries(
          staffMembers.map((s) => s.uid),
          currentUser.companyId,
          start,
          end,
          currentUser.uid,
        );
        setPendingApprovals(
          entries.filter((e) => e.status === "pending").length,
        );
        setTotalHours(entries.reduce((sum, e) => sum + e.paidHours, 0));
      }
    } catch (error) {
      console.error("Error loading dashboard stats:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingState message="Loading dashboard..." />;

  return (
    <div style={{ padding: SPACING["2xl"] }}>
      <PageHeader
        title="Dashboard"
        subtitle="Overview of your team's activity"
      />

      <DashboardGrid columns={3}>
        <StatCard
          title="Team Members"
          value={teamMembers}
          icon={StatIcons.users}
          color={COLORS.primary.light}
          iconColor={COLORS.primary.dark}
          subtitle="Staff under management"
          onClick={() => navigate("/team")}
        />
        <StatCard
          title="Pending Approvals"
          value={pendingApprovals}
          icon={StatIcons.clock}
          color={COLORS.warning.light}
          iconColor={COLORS.warning.dark}
          subtitle="Awaiting review"
          onClick={() => navigate("/approvals")}
        />
        <StatCard
          title="Total Hours"
          value={`${totalHours.toFixed(1)}h`}
          icon={StatIcons.barChart}
          color={COLORS.success.light}
          iconColor={COLORS.success.dark}
          subtitle="This month"
          onClick={() => navigate("/time-entries")}
        />
      </DashboardGrid>
    </div>
  );
}
